// Why-and-how support page. The tip button uses the Stripe Payment Link in
// VITE_DONATE_URL; the Creator Council is the deeper way to back the project.

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Heart, Crown } from 'lucide-react';
import './LandingPage.css';

const DONATE_URL = import.meta.env.VITE_DONATE_URL as string | undefined;

const SupportPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-container" style={{ minHeight: '100dvh' }}>
      <div className="landing-glow" />
      <div className="landing-content" style={{ paddingBottom: 60 }}>
        <nav className="landing-nav" style={{ marginBottom: 8 }}>
          <div className="nav-logo" style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
            Gathr<span className="nav-logo-accent">XR</span>
          </div>
          <button className="nav-btn" onClick={() => navigate(-1)}>
            <ArrowLeft size={15} /> Back
          </button>
        </nav>

        <section style={{ textAlign: 'center', padding: '52px 0 12px', maxWidth: 620, margin: '0 auto' }}>
          <div className="hero-badge">
            <span className="hero-badge-dot" />
            Independent and member-supported
          </div>
          <h1 style={{ fontSize: 44, fontWeight: 800, color: 'rgba(234,246,248,0.95)', letterSpacing: '-1.2px', margin: '18px 0 14px', lineHeight: 1.08 }}>
            Help GathrXR <span className="hero-title-accent">grow</span>
          </h1>
          <p style={{ fontSize: 17, color: 'rgba(234,246,248,0.62)', lineHeight: 1.65, margin: 0 }}>
            GathrXR is independent — no investors, no ads, no selling your data.
            If GathrXR is useful to you, a contribution helps pay for servers and
            AI and keeps new features coming.
          </p>
        </section>

        <section style={{ textAlign: 'center', marginTop: 32 }}>
          {DONATE_URL ? (
            <a
              href={DONATE_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex', alignItems: 'center', gap: 10,
                padding: '16px 38px', borderRadius: 999, textDecoration: 'none',
                fontSize: 16, fontWeight: 700, fontFamily: 'Outfit, sans-serif', color: '#fff',
                background: 'linear-gradient(135deg, #00c2b3, #0077b6)',
                boxShadow: '0 12px 36px rgba(0,194,179,0.28)',
              }}
            >
              <Heart size={18} /> Support GathrXR
            </a>
          ) : (
            <a href="mailto:support@gathrxr.com?subject=Supporting%20GathrXR" style={{ color: '#00c2b3' }}>Contact us to support GathrXR</a>
          )}
          <p style={{ fontSize: 12.5, color: 'rgba(234,246,248,0.4)', marginTop: 14 }}>
            One-time contribution of any amount, securely through Stripe. No account needed.
          </p>
        </section>

        <section
          style={{
            marginTop: 48, maxWidth: 640, marginLeft: 'auto', marginRight: 'auto',
            borderRadius: 18, padding: '26px 28px', textAlign: 'center',
            background: 'rgba(0,194,179,0.07)', border: '1px solid rgba(0,194,179,0.3)',
          }}
        >
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, color: '#ffd166', fontWeight: 700, fontSize: 13, letterSpacing: '0.05em' }}>
            <Crown size={16} /> WANT TO GO DEEPER?
          </div>
          <p style={{ fontSize: 14.5, color: 'rgba(234,246,248,0.7)', lineHeight: 1.6, margin: '10px 0 16px' }}>
            The <strong style={{ color: 'rgba(234,246,248,0.95)' }}>Creator Council</strong> is our
            limited founding circle — monthly AI building resources, founding
            recognition, and a real voice in where GathrXR goes.
          </p>
          <button
            onClick={() => navigate('/council')}
            style={{
              padding: '12px 28px', borderRadius: 999, border: '1px solid rgba(0,194,179,0.5)',
              background: 'transparent', color: '#00c2b3', fontSize: 14, fontWeight: 700,
              fontFamily: 'Outfit, sans-serif', cursor: 'pointer',
            }}
          >
            Explore the Creator Council
          </button>
        </section>

        <footer className="landing-footer">
          <span>&copy; {new Date().getFullYear()} GathrXR. All rights reserved.</span>
          <div className="footer-links">
            <a href="/">Home</a>
            <a href="/council">Creator Council</a>
            <a href="mailto:support@gathrxr.com">Contact</a>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default SupportPage;
